import React, { useState } from "react";

const DischargeTransfer = ({ data, updateData }) => {
  const [formData, setFormData] = useState({
    dischargeSummary: data.dischargeSummary || "",
    followUpInstructions: data.followUpInstructions || "",
    transferFacilityName: data.transferFacilityName || "",
    modeOfTransfer: data.modeOfTransfer || "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    updateData({ [field]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Discharge/Transfer Data Submitted:", formData);
  };

  return (
    <div className="p-6 bg-white rounded shadow-md">
      <h2 className="text-xl font-semibold mb-4">Discharge/Transfer</h2>
      <form onSubmit={handleSubmit}>
        {/* Discharge Summary */}
        <div className="mb-4">
          <label
            htmlFor="dischargeSummary"
            className="block text-sm font-medium text-gray-700"
          >
            Discharge Summary
          </label>
          <textarea
            id="dischargeSummary"
            value={formData.dischargeSummary}
            onChange={(e) => handleChange("dischargeSummary", e.target.value)}
            placeholder="Enter discharge summary"
            rows="4"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>

        {/* Follow-Up Instructions */}
        <div className="mb-4">
          <label
            htmlFor="followUpInstructions"
            className="block text-sm font-medium text-gray-700"
          >
            Follow-Up Instructions
          </label>
          <textarea
            id="followUpInstructions"
            value={formData.followUpInstructions}
            onChange={(e) =>
              handleChange("followUpInstructions", e.target.value)
            }
            placeholder="Enter follow-up instructions"
            rows="4"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>

        {/* Transfer Facility Name */}
        <div className="mb-4">
          <label
            htmlFor="transferFacilityName"
            className="block text-sm font-medium text-gray-700"
          >
            Transfer Facility Name
          </label>
          <input
            type="text"
            id="transferFacilityName"
            value={formData.transferFacilityName}
            onChange={(e) =>
              handleChange("transferFacilityName", e.target.value)
            }
            placeholder="Enter facility name"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>

        {/* Mode of Transfer */}
        <div className="mb-4">
          <label
            htmlFor="modeOfTransfer"
            className="block text-sm font-medium text-gray-700"
          >
            Mode of Transfer
          </label>
          <select
            id="modeOfTransfer"
            value={formData.modeOfTransfer}
            onChange={(e) => handleChange("modeOfTransfer", e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="" disabled>
              Select mode of transfer
            </option>
            <option value="Ambulance">Ambulance</option>
            <option value="Private Vehicle">Private Vehicle</option>
            <option value="Other">Other</option>
          </select>
        </div>

        {/* Submit Button */}
        <div className="mt-6">
          <button
            type="submit"
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default DischargeTransfer;
